import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const environments = [{
  title: "Homes",
  description: "Sanctuaries of peace and purity.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558603/img/sunlit_nursery_home.png",
  href: "#"
}, {
  title: "Schools",
  description: "Inspiring minds with clarity.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558603/img/modern_library_school.png",
  href: "#"
}, {
  title: "Offices",
  description: "Elevating focus and productivity.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558603/img/glass_boardroom_office.png",
  href: "#"
}];
export default function SanctuaryEnvironments() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="sanctuary-environments" ref={ref} className={cn("w-full bg-background py-32 lg:py-48 transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-24 max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-light tracking-tight text-foreground mb-6">
            Designed for Life
          </h2>
          <p className="text-muted-foreground text-lg font-light leading-relaxed">
            Experience the feeling of pure air in the spaces that matter most.
            Our technology integrates seamlessly into your environment, creating
            invisible sanctuaries of wellness.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {environments.map((env, i) => <Link key={i} to={env.href} className="group block h-full" data-index={i}>
              <Card className="h-[500px] md:h-[600px] w-full overflow-hidden rounded-none border-0 bg-transparent shadow-none relative">
                <CardContent className="p-0 h-full w-full relative overflow-hidden">
                  {}
                  <div className="absolute inset-0 w-full h-full overflow-hidden">
                    <img src={env.image} alt={env.title} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
                    {}
                    <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors duration-500" />
                  </div>

                  {}
                  <div className="absolute inset-0 flex flex-col justify-between p-8 md:p-10">
                    {}
                    <div>
                      <h3 className="text-2xl md:text-3xl font-light text-white tracking-wide drop-shadow-md">
                        {env.title}
                      </h3>
                      <p className="mt-2 text-white/80 font-light text-sm tracking-wider opacity-0 transform -translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0 delay-100">
                        {env.description}
                      </p>
                    </div>

                    {}
                    <div className="overflow-hidden">
                      <div className="transform translate-y-full transition-transform duration-500 ease-out group-hover:translate-y-0">
                        <Button variant="link" className="text-white p-0 h-auto font-normal text-sm tracking-widest uppercase hover:no-underline hover:text-white/90 flex items-center gap-2">
                          View Specifications
                          <ArrowRight className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}